import { nanoid } from 'nanoid'
import type * as React from 'react'

export const domUtils = {
  onEnter:
    (fn: React.KeyboardEventHandler<HTMLInputElement>) =>
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') fn(e)
    },
  hexToRgbA(hex: string, opacity = 1) {
    let c
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('')
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]]
      }
      c = '0x' + c.join('')
      return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},${opacity})`
    }
    throw new Error('Bad Hex')
  },
  // dom id에 첫글자 숫자가 들어가면 안되서 만듬
  uniqueId: () => {
    return `_${nanoid()}`
  },
}
